<template>
        <v-card class="elevation-12">
            <v-toolbar dark color="primary">
                <v-toolbar-title>{{trans('userpanel.change-password.title')}}</v-toolbar-title>
            </v-toolbar>
            <v-card-text v-if="!submitted">

                <v-alert
                        :value="true"
                        v-if="error"
                        type="error"
                        >{{error}}
                        </v-alert>
                <v-form
                    ref="form"
                    @submit.prevent
                    v-model="validForm"
                    >
                    <v-text-field
                            prepend-icon="vpn_key"
                            name="password"
                            :label="trans('userpanel.change-password.old_password')"
                            type="password"
                            v-model="old_password"
                            required
                            :error-messages="fieldErrors.old_password"
                            @input="fieldErrors.old_password=null;error=null;"
                            :rules="rules.old_password"
                            :loading="loading"

                            ></v-text-field>
                    <v-text-field
                            prepend-icon="lock"
                            name="password"
                            :label="trans('userpanel.change-password.password')"
                            type="password"
                            v-model="new_password"
                            required
                            :error-messages="fieldErrors.new_password"
                            @input="error=null;fieldErrors.new_password=null"
                            :rules="rules.new_password"
                            :loading="loading"
                            ></v-text-field>
                    <v-text-field
                            prepend-icon="lock"
                            name="password"
                            :label="trans('userpanel.change-password.confirm')"
                            type="password"
                            v-model="confirm"
                            required
                            :error-messages="fieldErrors.confirm"
                            @input="error=null;fieldErrors.confirm=null"
                            :rules="rules.confirm"
                            :loading="loading"
                            ></v-text-field>

                </v-form>
            </v-card-text>
            <v-card-text v-else class="success white--text text-center pa-4">
                <div><v-icon class=" white--text" x-large>check_circle_outline</v-icon></div>
                {{trans('userpanel.change-password.success')}}
            </v-card-text>
            <v-card-actions>

                <v-spacer></v-spacer>
                <v-btn
                    v-if="!submitted"
                    :disabled="!validForm"
                    color="primary"
                    @click="submit"
                    :loading="loading"
                    ><v-icon left>send</v-icon>{{trans('userpanel.change-password.submit')}}</v-btn>


                <v-btn
                        text
                        small
                        :loading="loading"

                        @click="cancel"
                        >{{trans('userpanel.change-password.cancel')}}</v-btn>

                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
</template>

<script>
    export default {
        name: "EditPassword",
        props:{
            action:{default:'/userpanel/password'},
            method:{default:'patch'},
            minLength:{type:Number,default:4},
        },
        data(){
            return {
                model:this.value,
                error:null,
                validForm:false,
                fieldErrors:{},
                loading:false,
                submitted:false,

                rules:{
                    old_password: [v=> (v && v.trim().length>3) || trans('validation.required'),],
                    new_password:[v=> (v && v.trim().length >= this.minLength) || trans('validation.required')],
                    confirm:[
                        v=> ( v && v.trim().length>=this.minLength ) || trans('validation.required'),
                        v=> v===this.new_password || trans('validation.confirmed'),
                    ],
                },
                old_password:'',
                new_password:'',
                confirm:'',
            }
        },
        computed:{
        },
        methods:{
            submit(){
                this.loading=true;
                axios.post(this.action,{
                    old_password:this.old_password,
                    new_password:this.new_password,
                    _method:this.method
                })
                    .then(r=>{
                        let redirect = (r.data && r.data.redirect)?r.data.redirect:null;
                        this.$emit('success',{response:r,redirect});
                        this.submitted=true;
                    })
                    .catch(e=>{
                        console.error(e);
                        if(e.response){
                            if(e.response.data){
                                console.log({e});
                                if(e.response.status===422){
                                    this.fieldErrors = e.response.data.errors;
                                }

                                this.error = e.response.data.message;
                            }
                            else{
                                this.error=e.response;
                            }
                        }else{
                            this.error=e;
                        }
                    })
                    .finally(()=>{this.loading=false});

            },
            cancel(){this.$emit('close')},

        },

    }
</script>
